import { Box, Typography } from '@mui/material'
import type { FC } from 'react'
import Heading from './Heading'
import type { ExperienceItem } from './types'

const ed: ExperienceItem[] = [
  {
    institution: 'Florida State University',
    description: 'Ph.D. · Musicology',
    endDate: '2020'
  },
  {
    institution: 'Florida State University',
    description: 'Master of Music · Historical Musicology',
    endDate: '2012'
  },
  {
    institution: 'Appalachian State University',
    description: 'Bachelor of Music · Violin Performance',
    endDate: '2010',
    subString: 'History Minor'
  }
]

const Education: FC = () => {
  return (
    <section className='about-section'>
      <Heading heading='Education' />
      <Box className='education-grid'>
        {ed.map(({ institution, description, endDate, subString }) => (
          <Box className='education-card' key={`${institution}-${description}`} component='article'>
            <Typography className='education-card__year' component='span'>
              {endDate}
            </Typography>
            <Typography className='education-card__school' component='h3' variant='h6'>
              {institution}
            </Typography>
            <Typography className='education-card__degree' variant='body2'>
              {description}
            </Typography>
            {subString != null && (
              <Typography className='education-card__minor' variant='caption' component='p'>
                {subString}
              </Typography>
            )}
          </Box>
        ))}
      </Box>
    </section>
  )
}

export default Education
